import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import keyBy from "lodash.keyby"
import { Form } from "antd"
import { useOutletContext } from "react-router-dom"

import api from "@api"
import { CreateModal } from "@components/Page"

import getCreateInputs from "./helpers/getCreateInputs"
import renderBrokerOptionLabel from "./helpers/renderBrokerOptionLabel"
import renderInvestorExistsAlert from "./helpers/renderInvestorExistsAlert"

const LABEL_ENTITY = "Investor"
const LABEL_CREATE = `Create ${LABEL_ENTITY}`

const createOperation = api.get("investments/CreateAccount")


const InvestorCreateModal = ({ modal, openInvestorDrawer }) => {
  const [ schema, setSchema ] = useState([])

  const [ form ] = Form.useForm()

  const {
    accounts,
    addAccount,
    brokersMap,
    sponsorsMap,
    referralSourceOptions
  } = useOutletContext()

  const accountsMapByEmail = useMemo(() =>
    keyBy(accounts, 'investor.email')
  , [accounts])

  const brokerOptions = useMemo(() =>
    Object
      .values(brokersMap)
      .map(({ fullName, sponsorId, id: value }) =>
        ({ label: renderBrokerOptionLabel(fullName, sponsorId, sponsorsMap), value }))
  , [ brokersMap ])

  const investorEmailValue = Form.useWatch([ "investor", "email" ], form)

  useEffect(() => {
    const createInputs = getCreateInputs(brokerOptions, referralSourceOptions)
    const createSchema = createOperation.getSchema(createInputs)

    setSchema(createSchema)
  }, [])

  useEffect(() => {
    let alert

    if (investorEmailValue) {
      alert = renderInvestorExistsAlert(accountsMapByEmail, investorEmailValue)
    }

    const createInputs = getCreateInputs(brokerOptions, referralSourceOptions, alert)
    const createSchema = createOperation.getSchema(createInputs)

    setSchema(createSchema)
  }, [investorEmailValue, referralSourceOptions])

  const onSuccess = newInvestor => {
    addAccount(newInvestor)
    openInvestorDrawer(newInvestor.id)
  }

  return (
    <CreateModal
      form={form}
      modal={modal}
      title={LABEL_CREATE}
      entity={LABEL_ENTITY}
      schema={schema}
      operation={createOperation.id}
      onSuccess={onSuccess}
      successMessage={false}
    />
  )
}

InvestorCreateModal.propTypes = {
  modal: PropTypes.shape().isRequired,
  openInvestorDrawer: PropTypes.func.isRequired,
}

export default InvestorCreateModal
